module.exports = __webpack_public_path__ + "img/entranceImage.b273336b.png";